import type { LabelFieldType } from '../../../../api/drive-labels-api';

import AccountCircleOutlined from '@mui/icons-material/AccountCircleOutlined';
import CalendarTodayOutlined from '@mui/icons-material/CalendarTodayOutlined';
import DragHandle from '@mui/icons-material/DragHandle';
import FeaturedPlayListOutlined from '@mui/icons-material/FeaturedPlayListOutlined';
import FormatListBulleted from '@mui/icons-material/FormatListBulleted';
import PinOutlined from '@mui/icons-material/PinOutlined';
import ShortText from '@mui/icons-material/ShortText';
import type { SvgIconProps } from '@mui/material/SvgIcon';

const ICONS: Record<LabelFieldType, typeof ShortText> = {
  BADGE_LIST: FeaturedPlayListOutlined,
  SINGLE_SELECT: DragHandle,
  MULTI_SELECT: FormatListBulleted,
  NUMBER: PinOutlined,
  DATE: CalendarTodayOutlined,
  TEXT: ShortText,
  PERSON: AccountCircleOutlined,
};

export default function FieldTypeIcon({
  type,
  ...props
}: { type: LabelFieldType } & SvgIconProps) {
  const Icon = ICONS[type];
  return <Icon fontSize="small" {...props} />;
}
